import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const URLInput = ({ value, onChange }) => {
  const [isValid, setIsValid] = useState(true);
  const [validationMessage, setValidationMessage] = useState('');

  useEffect(() => {
    if (!value) {
      setIsValid(true);
      setValidationMessage('');
      return;
    }

    try {
      const url = new URL(value);
      if (url?.protocol === 'http:' || url?.protocol === 'https:') {
        setIsValid(true);
        setValidationMessage('');
      } else {
        setIsValid(false);
        setValidationMessage('URL must start with http:// or https://');
      }
    } catch {
      setIsValid(false);
      setValidationMessage('Please enter a valid URL');
    }
  }, [value]);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Icon name="Link" size={18} color="var(--color-accent)" strokeWidth={2} />
        <label className="text-sm font-caption font-medium text-foreground">
          Enter Website URL
        </label>
      </div>
      <Input
        type="url"
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder="https://example.com"
        error={!isValid ? validationMessage : ''}
      />
      {isValid && value && (
        <div className="flex items-center gap-2 text-xs font-caption text-success">
          <Icon name="CheckCircle" size={14} color="var(--color-success)" strokeWidth={2} />
          <span>Valid URL format</span>
        </div>
      )}
    </div>
  );
};

export default URLInput;